import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Input,
	ViewChild,
	OnDestroy,
	Output,
	EventEmitter,
} from "@angular/core";
import { SharedService } from "../../../../../shared/sharedServices/shared.service";
import { HecResponse } from "../../../../../shared/shared-interfaces/hecResponse";
import { HEC_CONSTANTS } from "../../../../../utilities/constants";
import { PucaComponent } from "../../puca.component";
import {
	NgForm,
	FormGroup,
	FormBuilder,
	FormArray,
	FormControl,
} from "@angular/forms";
import { MatDialog, MatSnackBar, MatTabGroup } from "@angular/material";
import { QuestionnaireComponent } from "../../../../../shared/shared-components/modal/questionnaire/questionnaire.component";
import { PucaFormService } from "./puca-form.service";
import { decrypt, encrypt } from "../../../../../utilities/utilityFunctions";
import { Router } from "@angular/router";
import { LoaderService } from "../../../../../shared/sharedServices/loader.service";
import { GoogleAnalyticsService } from "../../../../../shared/sharedServices/google-analytics.service";
import { PucaDataService } from "../../services/puca-data.service";
import { UploadAdditionalDocumentsService } from "../../../../../shared/shared-components/upload-additional-documents/services/upload-additional-documents.service";
import { AttestationModel } from "../attestation-details/model/attestationModel";
@Component({
	selector: "kt-puca-form",
	templateUrl: "./puca-form.component.html",
	styleUrls: ["./puca-form.component.scss"],
})
export class PucaFormComponent implements OnInit, OnDestroy {
	public loader: boolean = false;
	public commentsList: Array<any>;
	public formViewType: any;
	public educationDetailsData: any = [];
	public educationDetailGridData: any = [];
	public viewform: boolean = false;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public dateError: string = "";
	public educationDetailsGridDetails: any;
	public selectedEducation: any;
	public isEductaionSelected: boolean = false;
	public commonProfileId: string;
	@Output() educationData = new EventEmitter();
	public eduForm: FormGroup;
	@Input("dropdownValuesForDas") dropdownValuesForDas: any;
	@Input("dropdownList") dropdownList: any;
	public alertType: string;
	public formView: string = "";
	@Input("dasApplicationData")
	dasApplicationData: AttestationModel = new AttestationModel();
	@Input() pucaApplication: any;
	@Output() updateDasAppData = new EventEmitter();
	public selectedIndex: number = 0;
	@ViewChild("mTabGroup", { static: false }) tabGroup: MatTabGroup;
	@Input('formType') formType: string;
	@Input() isAdmin: boolean = false;
	constructor(
		private sharedServices: SharedService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder,
		private gaService: GoogleAnalyticsService,
		private router: Router,
		private loaderService: LoaderService,
		private dasDataservice: PucaDataService,
		private matDialog: MatDialog,
		private educationServices: PucaFormService,
		private parentComp: PucaComponent,
		public _snackBar: MatSnackBar,
		private uploadAdditionalService: UploadAdditionalDocumentsService,
		private pucaFormService: PucaFormService,
		private pucaDataService: PucaDataService
	) {
		if (localStorage.getItem("edu")) {
			this.selectedEducation = JSON.parse(
				decrypt(localStorage.getItem("edu"))
			);
		}
		let data = decrypt(localStorage.getItem("esp-profile-details"));
		data = JSON.parse(data);
		this.commonProfileId = data["profileId"];
		this.createEducationForm();
		//puca form service subject subscribe
		this.pucaFormService.nextStep.subscribe((step) => {
			this.nextStep();
		});
		this.pucaFormService.previousStep.subscribe((step) => {
			this.previousStep();
		});
	}
	async ngOnInit() {
		window.scroll(0, 0);
		this.gaService.setPage("/form", "ESP Page");
		this.formView = this.parentComp.formType;
		await this.getDasComments(this.dasApplicationData.dasApplicationDto.id);
		this.getEducationDetails();
	}
	ngOnDestroy() {
		this.dasDataservice.formView = undefined;
		this.dasDataservice.applicationId = undefined;
		localStorage.removeItem("edu");
	}
	private createEducationForm(): void {
		this.eduForm = this.fb.group({
			eduDtoList: this.fb.array([]),
		});
	}
	public getEducationList(): any {
		return this.eduForm.controls.eduDtoList["controls"];
	}
	public addNewEdu(data): void {
		const eduValues = this.eduForm.controls.eduDtoList as FormArray;
		let newRow = this.fb.group({
			isChecked: new FormControl(),
			eduId: new FormControl(data.educationId ? data.educationId : null),
			eduHistoryId: new FormControl(
				data.eduationHistoryId ? data.eduationHistoryId : null
			),
			universityName: new FormControl(
				data.universityName ? data.universityName : ""
			),
			degreeProgramName: new FormControl(
				data.countryId == 1
					? data.degreeProgramName
					: data.otherProgramTitle
			),
		});
		eduValues.push(newRow);
	}
	public deleteEducationRow(eduInd): void {
		const eduForm = this.eduForm.controls.eduDtoList as FormArray;
		eduForm.removeAt(eduInd);
		this.eduForm.value.eduDtoList--;
	}
	public getEducationDetails() {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			this.deleteEducationRow(0);
		}
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.cdr.detectChanges();
		this.sharedServices.getEducationDetails().subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.educationDetailsGridDetails = res.data;
					for (let i = 0; i < res.data.length; i++) {
						if (
							res.data[i].qualificationId != 7 &&
							res.data[i].qualificationId != 8 &&
							res.data[i].qualificationId != 18 &&
							res.data[i].qualificationId != 20
						) {
							// if(res.data[i].countryId !=1 && !res.data[i].isCurrentEnrolment){
							this.educationDetailGridData.push(res.data[i]);
							this.addNewEdu(res.data[i]);
							// }
						} else {
						}
					}
					if (this.selectedEducation) {
						for (
							let i = 0;
							i < this.educationDetailGridData.length;
							i++
						) {
							if (
								this.selectedEducation.educationId ==
								this.educationDetailGridData[i].educationId
							) {
								this.eduForm.controls.eduDtoList["controls"][
									i
								].controls.isChecked.patchValue(true);
							}
						}
					} else if (
						this.dasApplicationData.dasApplicationDto
							.commonProfileId &&
						this.dasApplicationData.dasApplicationDto.dasDegrees
							.length > 0
					) {
						for (
							let i = 0;
							i <
							this.dasApplicationData.dasApplicationDto.dasDegrees
								.length;
							i++
						) {
							for (
								let j = 0;
								j < this.educationDetailGridData.length;
								j++
							) {
								if (
									this.dasApplicationData.dasApplicationDto
										.dasDegrees[i].educationHistoryDto
										.educationId ==
									this.educationDetailGridData[j].educationId
								) {
									this.eduForm.controls.eduDtoList[
										"controls"
									][j].controls.isChecked.patchValue(true);
								}
								this.commentsList.forEach((element, index) => {
									if (
										element.degreeId ==
										this.dasApplicationData
											.dasApplicationDto.dasDegrees[i]
											.cpEducationHistoryId
									) {
										this.commentsList[
											index
										].eduId = this.dasApplicationData.dasApplicationDto.dasDegrees[
											i
										].educationHistoryDto.educationId;
									}
								});
							}
						}
					}
				} else {
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
			}
		);
		if (this.formView == "view") {
			setTimeout(() => {
				this.eduForm.disable();
				this.eduForm.controls.eduDtoList.disable();
			}, 1000);
		}
		setTimeout(() => {
			this.educationDetailGridData.forEach((element, index) => {
				if (element.countryId != 1 && element.isCurrentEnrolment) {
					setTimeout(() => {
						this.eduForm.controls.eduDtoList["controls"][
							index
						].controls.isChecked.disable();
					}, 500);
				}
			});
		}, 500);
	}
	public async getDasComments(appId): Promise<any> {
		if (appId) {
			try {
				this.loader = true;
				this.loaderService.setValue(this.loader);
				const res = await this.uploadAdditionalService
					.getDasComments(appId)
					.toPromise();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.commentsList = [];
					res.data.forEach((element) => {
						if (element.degreeId) {
							this.commentsList.push(element);
						}
					});
					this.loader = false;
					this.loaderService.setValue(this.loader);
				} else {
				}
			} catch (err) {
				this.loader = false;
				this.loaderService.setValue(this.loader);
			}
		}
	}
	public goNext() {
		this.parentComp.goNext();
		this.cdr.detectChanges();
	}
	public goBack() {
		this.parentComp.goBack();
		this.cdr.detectChanges();
	}
	public async openEducationDetails(data, index, type) {
		this.formViewType = type;
		this.educationDetailsData = data;
		this.viewform = true;
		this.cdr.detectChanges();
		if (type == "view") {
			this._snackBar.open(
				"You're in view mode! To exit, please click Cancel button to continue with your Application Form",
				"",
				{
					duration: 9500,
					panelClass: ["error-snackbar"],
				}
			);
		} else if (type == "edit") {
			this._snackBar.open(
				"You're in edit mode! To exit, please click Cancel button to continue with your Application Form",
				"",
				{
					duration: 9500,
					panelClass: ["error-snackbar"],
				}
			);
		}
	}
	public deleteEducation(educationData) {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		educationData.activeIndicator = false;
		let payload = {
			data: educationData,
		};
		this.sharedServices.saveOrUpdateEducation(payload).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.getEducationDetails();
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.isAlertVisible = true;
					this.alertType = "error";
					this.alertMsgValue = "Error in deleting Education";
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.isAlertVisible = true;
				this.alertType = "error";
				this.alertMsgValue = "Error in deleting Education";
				this.cdr.detectChanges();
			}
		);
	}
	public getDate(date): any {
		let convertedDate = new Date(date).toISOString();
		return convertedDate;
	}
	public getCommentDate(date): void {
		return this.sharedServices.getDate(date);
	}
	public addNewEducation() {
		this.formViewType = "new";
		this.educationDetailsData = [];
		this.viewform = true;
		this.cdr.detectChanges();
		this.cdr.markForCheck();
	}
	// private alertBoxMsg(message, alertType?) {
	//   if (alertType == 'success') {
	//     this.alertClass = 'alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40';
	//     this.alertIcon = 'fa fa-check-circle'
	//   } else if (alertType == 'warning') {
	//     this.alertClass = 'alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40';
	//     this.alertIcon = 'fas fa-exclamation-circle'
	//   } else if (alertType == 'info') {
	//     this.alertClass = 'alert alert-solid-info alert-bold fade show kt-margin-t-20 kt-margin-b-40';
	//     this.alertIcon = 'fas fa-lightbulb'
	//   }
	//   else {
	//     this.alertClass = 'alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40';
	//     this.alertIcon = 'fa fa-exclamation-triangle'
	//   }
	//   this.alertMsgValue = message;
	// }
	public getUpdatedEducation(educationStatus) {
		this.viewform = false;
		this.isAlertVisible = true;
		this.formViewType = undefined;
		if (educationStatus.id) {
			this.alertType = "success";
			this.alertMsgValue = "Education Update Successfully";
		} else {
			this.alertType = "success";
			this.alertMsgValue = "Education Added Successfully";
		}
		this.getEducationDetails();
		setTimeout(() => {
			this.isAlertVisible = false;
			this.cdr.detectChanges();
		}, 3000);
	}
	public async submitEducation(type) {
		if (this.formView != "view") {
			this.isEductaionSelected = false;
			for (let i = 0; i < this.eduForm.value.eduDtoList.length; i++) {
				if (this.eduForm.value.eduDtoList[i].isChecked) {
					this.isEductaionSelected = true;
				} else {
				}
			}
			if (this.isEductaionSelected) {
				this.isAlertVisible = false;
				this.loader = true;
				this.loaderService.setValue(this.loader);
				let payload = this.constructPayload();
				for (
					let ind = 0;
					ind < payload.data.dasApplicationDto.dasDegrees.length;
					ind++
				) {
					for (
						let degreeInd = 0;
						degreeInd <
						payload.data.dasApplicationDto.dasDegrees[ind]
							.degreeInfo.length;
						degreeInd++
					) {
						delete payload.data.dasApplicationDto.dasDegrees[ind]
							.degreeInfo[degreeInd].documentTypeCodeValue;
					}
				}
				if (this.formView == "pucaRevision") {
					for (
						let j = 0;
						j <
						this.dasApplicationData.dasApplicationDto.dasDegrees
							.length;
						j++
					) {
						for (
							let k = 0;
							k <
							payload.data.dasApplicationDto.dasDegrees.length;
							k++
						) {
							if (
								this.dasApplicationData.dasApplicationDto
									.dasDegrees[j].educationHistoryDto
									.educationId ==
								payload.data.dasApplicationDto.dasDegrees[k]
									.educationHistoryDto.educationId
							) {
								(payload.data.dasApplicationDto.dasDegrees[
									k
								].id = this.dasApplicationData.dasApplicationDto.dasDegrees[
									j
								].id),
									(payload.data.dasApplicationDto.dasDegrees[
										k
									].degreeInfo = this.dasApplicationData.dasApplicationDto.dasDegrees[
										j
									].degreeInfo);
							}
						}
					}
					payload.data.dasApplicationDto[
						"applicationStatusCodeId"
					] = 600827;
				}
				this.educationServices.saveApplicationData(payload).subscribe(
					async (res: HecResponse) => {
						this.loader = false;
						this.loaderService.setValue(this.loader);
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.updateDasAppData.emit(
								res.data.dasApplicationDto
							);
							this.isAlertVisible = false;
							this.educationData.emit(res.data.dasApplicationDto);
							if (
								this.dasApplicationData.dasApplicationDto
									.isQuestionnaireFilled == undefined
							) {
								this.ModalComponent(
									QuestionnaireComponent,
									this.dropdownValuesForDas
										.dasQuestionnaireDtoList
								);
							} else if (
								this.dasApplicationData.dasApplicationDto
									.isQuestionnaireFilled
							) {
								if (type == "next") {
									this.goNext();
								} else if (type == "save") {
									this.router.navigate(["/dashboard"]);
								}
							}
						} else if (
							res.statusCode ==
							HEC_CONSTANTS.HTTP_RESPONSE.NADRA_SERVICE_ERROR
						) {
							this.isAlertVisible = true;
							this.alertType = "error";
							this.alertMsgValue = "Application is already Exist";
							this.loader = false;
							this.loaderService.setValue(this.loader);
							this.cdr.detectChanges();
						} else {
							this.isAlertVisible = true;
							this.alertType = "error";
							this.alertMsgValue = "Something Went wrong";
							this.loader = false;
							this.loaderService.setValue(this.loader);
							this.cdr.detectChanges();
						}
					},
					(err) => {
						this.loader = false;
						this.loaderService.setValue(this.loader);
						this.cdr.detectChanges();
					}
				);
			} else {
				this.isAlertVisible = true;
				this.alertType = "error";
				this.alertMsgValue = "Please Select at least one education";
			}
		} else {
			this.goNext();
		}
	}
	public submitQuestionnaire(): void {
		let payload = this.constructPayload();
		payload.data.dasApplicationDto["isQuestionnaireFilled"] = true;
		this.educationServices.saveApplicationData(payload).subscribe(
			async (res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.updateDasAppData.emit(res.data.dasApplicationDto);
					this.educationData.emit(res.data.dasApplicationDto);
					this.goNext();
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
			}
		);
	}
	private constructPayload() {
		localStorage.removeItem("eduHistory");
		var dasDegrees = [];
		var educationHistoryDtos = [];
		for (let i = 0; i < this.eduForm.value.eduDtoList.length; i++) {
			if (
				this.educationDetailGridData[i].educationId ==
				this.eduForm.value.eduDtoList[i].eduId &&
				this.eduForm.value.eduDtoList[i].isChecked
			) {
				educationHistoryDtos.push(this.educationDetailGridData[i]);
				if (this.formView != "pucaRevision") {
					dasDegrees.push({
						cpEducationHistoryId: this.educationDetailGridData[i]
							.eduationHistoryId,
						nameOnDegree: decrypt(localStorage.getItem("name")),
						exactDegreeTitle:
							this.educationDetailGridData &&
								this.educationDetailGridData[i].countryId &&
								this.educationDetailGridData[i].countryId == 1
								? this.educationDetailGridData[i]
									.degreeProgramName
								: this.educationDetailGridData[i]
									.otherProgramTitle,
						universityNameOnDegree:
							this.educationDetailGridData[i].universityName &&
								this.educationDetailGridData[i].universityName !=
								"Other"
								? this.educationDetailGridData[i].universityName
								: this.educationDetailGridData[i]
									.otherUniversity,
						degreeInfo: [],
						id: null,
					});
				} else if (this.formView == "pucaRevision") {
					dasDegrees.push({
						cpEducationHistoryId: this.educationDetailGridData[i]
							.eduationHistoryId,
						nameOnDegree: decrypt(localStorage.getItem("name")),
						exactDegreeTitle:
							this.educationDetailGridData &&
								this.educationDetailGridData[i].countryId &&
								this.educationDetailGridData[i].countryId == 1
								? this.educationDetailGridData[i]
									.degreeProgramName
								: this.educationDetailGridData[i]
									.otherProgramTitle,
						universityNameOnDegree:
							this.educationDetailGridData[i].universityName &&
								this.educationDetailGridData[i].universityName !=
								"Other"
								? this.educationDetailGridData[i].universityName
								: this.educationDetailGridData[i]
									.otherUniversity,
						degreeInfo: [],
						educationHistoryDto: this.educationDetailGridData[i],
						id: null,
					});
				}
			} else {
			}
		}
		if (this.dasApplicationData) {
			for (
				let j = 0;
				j < this.dasApplicationData.dasApplicationDto.dasDegrees.length;
				j++
			) {
				for (let k = 0; k < dasDegrees.length; k++) {
					if (
						this.dasApplicationData.dasApplicationDto.dasDegrees[j]
							.cpEducationHistoryId ==
						dasDegrees[k].cpEducationHistoryId
					) {
						(dasDegrees[
							k
						].id = this.dasApplicationData.dasApplicationDto.dasDegrees[
							j
						].id),
							(dasDegrees[
								k
							].degreeInfo = this.dasApplicationData.dasApplicationDto.dasDegrees[
								j
							].degreeInfo);
					}
				}
			}
		}
		let payload = {
			data: {
				dasApplicationDto: {
					commonProfileId: this.commonProfileId,
					id:
						this.dasApplicationData &&
							this.dasApplicationData.dasApplicationDto.id
							? this.dasApplicationData.dasApplicationDto.id
							: null,
					dasDegrees: dasDegrees,
				},
			},
		};
		educationHistoryDtos = educationHistoryDtos.reverse();
		localStorage.setItem(
			"eduHistory",
			encrypt(JSON.stringify(educationHistoryDtos))
		);
		return payload;
	}
	public getDasFormDate() {
		return new Promise((resolve, reject) => {
			this.loader = true;
			this.loaderService.setValue(this.loader);
			this.educationServices.getPucaFormDetails().subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (
							this.dasApplicationData.dasApplicationDto
								.isQuestionnaireFilled == undefined
						) {
							this.ModalComponent(
								QuestionnaireComponent,
								res.data.dasQuestionnaireDtoList
							);
						} else if (
							this.dasApplicationData.dasApplicationDto
								.isQuestionnaireFilled
						) {
							this.goNext();
						}
					} else {
					}
				},
				(err) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
				}
			);
		});
	}
	public ModalComponent(Component, data) {
		const dialogRef = this.matDialog.open(Component, {
			width: "80vw",
			height: "70vh",
			backdropClass: "custom-scrutiny-popups",
			panelClass: "custom-scrutiny-popups",
			disableClose: true,
			autoFocus: false,
			data: { questions: data },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.submitQuestionnaire();
			} else {
				localStorage.setItem("questionnaire", encrypt("return"));
				this.router.navigate(["/dashboard"]);
			}
		});
	}
	public cancelEducation(event) {
		if (event == "cancel") {
			this.formViewType = undefined;
			this.viewform = false;
			this.cdr.detectChanges();
		}
	}
	public cancelAttestaion() {
		if (this.pucaDataService.isAdmin) {
			this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
		}
		else {
			this.router.navigate(['/'])
		}
	}


	nextStep() {
		if (this.selectedIndex != 4) {
			this.selectedIndex = this.selectedIndex + 1;
		}
	}

	previousStep() {
		if (this.selectedIndex != 0) {
			this.selectedIndex = this.selectedIndex - 1;
		}
	}

	setNewPucaApplication(value) {
		this.pucaFormService.setNewPucaApplication.next(value);
		this.pucaApplication = value
	}

}
